import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import "./users.css";

import { convertTimeString, getCurrentDate } from "../../utils/TimeUtils";
import MasterButton, {
  ButtonLayoutType,
  ButtonSize,
  ButtonVariation,
} from "../../components/button/MasterButton";
import refreshIcon from "../../assets/RefreshIcon.svg";

import InputfieldWithPlaceholder, { InputfieldType } from "../../components/inputfieldwithplaceholder/Inputfieldwithplaceholder";
import { SearchIcon } from "../../assets/SearchIcon";
import { ClearIcon } from "../../assets/ClearIcon";

import UsersTable from "./usersTable";

import { useSelector , useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../context/store';

import Skeleton from "../../components/skeleton/Skeleton";


// Define the type for user data, including userId
interface UserDetails {
  userId: string;
  name: string;
  email: string;
  role: string;
  lastLogin: string;
  status: string;
  invitedOn: string;
  organizationName: string; // Example: 'org-A'
  studyName: string; // Example: 'study-A'
  loginIcon: string;
}

type TableOptions = {
  tabName: string;
  isStudySelected: boolean;
  isStudyOrgSelected: boolean;
  networkError: boolean;
  isLoading: boolean;
}

const TableOptions : TableOptions = {
  tabName: "Users",
  isStudySelected: false,
  isStudyOrgSelected: true,
  networkError: false,
  isLoading: true,
}

const UserData : UserDetails[] = [
  {
    userId: "U001",
    name: "Alice Johnson",
    email: "alice.johnson@org.org",
    role: "Manager",
    lastLogin: "09/10/2024 4:15 PM",
    status: "Active",
    invitedOn: "08/20/2022",
    organizationName: "Organization A", 
    studyName: "Study A",
    loginIcon: "active"
  },
  {
    userId: "U002",
    name: "Bob Martin",
    email: "bob.martin@org.org",
    role: "Doctor",
    lastLogin: "09/15/2024 9:30 AM",
    status: "Invited",
    invitedOn: "07/14/2021",
    organizationName: "Organization A", 
    studyName: "Study B",
    loginIcon: "invited"
  },
  {
    userId: "U003",
    name: "Alex Freedman",
    email: "alex.freedman@org.org",
    role: "Nurse",
    lastLogin: "09/15/2024 9:30 AM",
    status: "Invite Expired",
    invitedOn: "07/14/2021",
    organizationName: "Organization B", 
    studyName: "Study A",
    loginIcon: "invite-expired"
  },
  {
    userId: "U004",
    name: "Bob Marley",
    email: "bob.marley@org.org",
    role: "Nurse",
    lastLogin: "09/15/2024 9:30 AM",
    status: "Error",
    invitedOn: "07/14/2021",
    organizationName: "Organization B", 
    studyName: "Study A",
    loginIcon: "error"
  },
];



const Users = () => {

  const [isLoading, setLoading] = useState(true);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [searchActive, setSearchActive] = useState(false);
  const scrollRef = useRef<HTMLDivElement>(null);




  const [refreshDate, setRefreshDate] = useState(getCurrentDate());

  const [searchQuery, setSearchQuery] = useState("");

  const [placeholderValue, setplaceholderValue] = useState("");

  const [isRefreshing, setRefereshing] = useState(false);

  const search = (query: string) => {
    console.log("Search Query:", query);
    setSearchQuery(query);
  };

  // Initialize an empty array of any type
  const [items, setItems] = useState<UserDetails[]>([]);

  const storeStudy = useSelector((state: RootState) => state.studyInfo);

  const [tableOptions, setTableOptions] = useState<TableOptions>({
    tabName: "Users",
    isStudySelected: false,
    isStudyOrgSelected: false,
    networkError: false,
    isLoading: true,
  });

  useEffect(()=> {

    let StudyOrg = storeStudy.study.StudyOrg
    let StudyName = storeStudy.study.StudyName
    
    if (storeStudy) {
      if(StudyOrg == "All Studies"){
        setTableOptions({
          tabName: "Users",
          isStudySelected: false,
          isStudyOrgSelected: false,
          networkError: false,
          isLoading: false,
        });
        setplaceholderValue("Enter ID, Org or Study")
      }else if(StudyName == ""){
        setTableOptions({
          tabName: "Users",
          isStudySelected: false,
          isStudyOrgSelected: true,
          networkError: false,
          isLoading: false,
        });
        setplaceholderValue("Enter ID or Study")
      }else{
        setTableOptions({
          tabName: "Users",
          isStudySelected: true,
          isStudyOrgSelected: true,
          networkError: false,
          isLoading: false,
        });
        setplaceholderValue("Enter ID")
      }
    }


  }, [storeStudy])

  useEffect(() => {

    setItems(UserData)

  }, [searchQuery] )

  const filteredData = UserData.filter((item: UserDetails) => {
    return (
      item.userId.toString().toUpperCase().includes(searchQuery.toUpperCase()) ||
      item.name.toString().toUpperCase().includes(searchQuery.toUpperCase()) ||
      (!tableOptions.isStudyOrgSelected && item.organizationName.toString().toUpperCase().includes(searchQuery.toUpperCase())) ||
      (!tableOptions.isStudySelected && item.studyName.toString().toUpperCase().includes(searchQuery.toUpperCase()))
    );
  });

  useEffect(() => {
    if(items.length > 0){
      setLoading(false)
    }
  }, [items.length])





  return (
    <>
      <div className="users-page">
      <div className="tab-header">
            <div className="left-section">
              <div className="title headline-small">Sensors</div>
              

            </div>

            <div className="quick-actions">
            <div className={`body-small refresh-date ${isRefreshing ? "loading" : ""}`}>
              {isRefreshing ? "Refreshing..." : `Updated on ${refreshDate}`}
            </div>
              <MasterButton
                options={{
                  layoutType: ButtonLayoutType.IconLabel,
                  label: "Refresh",
                  variation: ButtonVariation.Outlined,
                  icon: refreshIcon,
                  size: ButtonSize.Medium,
                }}
                onClick={() => {
                  console.log("master button refresh");
                  // reloadData()
                  // loadData(selectedStudy); // !!!!!!!!!!!!! Need to use the studyInfo state here to get the relevant study and load the data through the API
                }}
              ></MasterButton>
              <InputfieldWithPlaceholder
                collapsable={true}
                leftIcon={<SearchIcon fill={getComputedStyle(document.documentElement).getPropertyValue("--on-surface-variant")}></SearchIcon>}
                rightActionIcon={<ClearIcon fill={getComputedStyle(document.documentElement).getPropertyValue("--on-surface-variant")} />}
                onRightActionClicked={() => {
                  setSearchQuery("");
                  search("");
                  setSearchActive(false);
                }}
                value={searchQuery}
                onValueChanged={(value) => {
                  if (value !== "") {
                    setSearchActive(true);
                  } else {
                    setSearchActive(false);
                  }
                  setSearchQuery(value);
                  search(value);
                }}
                type={searchActive && items.length === 0 ? InputfieldType.Error : InputfieldType.Normal}
                placeholderValue={placeholderValue}
              ></InputfieldWithPlaceholder>

            </div>

          </div>

        <div className="content">
          <div className="static-place-holder"></div>
          <div className="table-info-section">
            {false ? (
              <Skeleton></Skeleton>
            ) : (
              <>
                <span className="display-small">4</span>
                <span>&nbsp;</span>
                <span className="title-small">Users</span>
              </>
            )}
          </div>
          <div className="separator"></div>
          <UsersTable UsersTableDataArray={UserData} TableOptions={tableOptions} ></UsersTable>
          
        </div>
      </div>
    </>
  );
};

export default Users;
